import React, { FC, useState } from 'react';
import cn from 'classnames';

import { Text, TextButton } from 'shared/components/ui';

import styles from '../CandidateSkills/index.module.scss';

interface Props {
	programming_languages: string[];
}

const ITEMS_TO_SHOW = 8;

export const CandidateProgLanguages: FC<Props> = ({ programming_languages }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOpen = () => {
		setIsOpen(open => !open);
	};

	const firstProgLanguages = programming_languages.slice(0, ITEMS_TO_SHOW);

	return (
		<div>
			<Text component="h3" variant="inter/18/semi" className={styles.title}>
				Programming languages ({programming_languages.length})
			</Text>
			<section className={cn(styles.section, styles.sectionProgramming)}>
				{firstProgLanguages.map(language => (
					<Text variant="inter/14/medium" key={language}>
						{language}
					</Text>
				))}
				{isOpen &&
					programming_languages.slice(ITEMS_TO_SHOW, programming_languages.length).map(language => (
						<Text variant="inter/14/medium" key={language}>
							{language}
						</Text>
					))}
			</section>
			{programming_languages.length > ITEMS_TO_SHOW && (
				<TextButton onClick={handleOpen} className={styles.open}>
					{isOpen ? 'See less' : `+${programming_languages.length - ITEMS_TO_SHOW} more`}
				</TextButton>
			)}
		</div>
	);
};
